import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const steps = [
  { num: '01', icon: '🔍', colorFrom: 'from-sky-500', colorTo: 'to-blue-600',    titleKey: 'howwework.step1.title', descKey: 'howwework.step1.desc' },
  { num: '02', icon: '📐', colorFrom: 'from-violet-500', colorTo: 'to-purple-600', titleKey: 'howwework.step2.title', descKey: 'howwework.step2.desc' },
  { num: '03', icon: '⚙️', colorFrom: 'from-emerald-500', colorTo: 'to-teal-600',  titleKey: 'howwework.step3.title', descKey: 'howwework.step3.desc' },
  { num: '04', icon: '🚀', colorFrom: 'from-orange-500', colorTo: 'to-red-500',    titleKey: 'howwework.step4.title', descKey: 'howwework.step4.desc' },
  { num: '05', icon: '📈', colorFrom: 'from-pink-500', colorTo: 'to-rose-600',    titleKey: 'howwework.step5.title', descKey: 'howwework.step5.desc' },
];

const guarantees = [
  { icon: '⚡', key: 'howwework.g1' },
  { icon: '🔒', key: 'howwework.g2' },
  { icon: '📦', key: 'howwework.g3' },
  { icon: '🤝', key: 'howwework.g4' },
];

export function HowWeWorkSection() {
  const { t } = useLanguage();

  return (
    <section id="how-we-work" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-primary/10 text-primary font-semibold text-sm px-4 py-1.5 rounded-full uppercase tracking-wide mb-4">
            {t('howwework.badge')}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('howwework.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('howwework.subtitle')}
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line (desktop) */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-0.5 bg-gradient-to-r from-sky-200 via-violet-200 via-emerald-200 to-rose-200 mx-32" />

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
            {steps.map((s, i) => (
              <div key={i} className="relative flex flex-col items-center text-center">

                {/* Icon circle */}
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${s.colorFrom} ${s.colorTo} flex items-center justify-center text-2xl shadow-lg mb-4 relative z-10`}>
                  {s.icon}
                </div>

                {/* Step number */}
                <span className="text-xs font-bold text-gray-400 tracking-widest mb-2">{s.num}</span>

                {/* Title */}
                <h3 className="text-base font-bold text-gray-900 mb-2">{t(s.titleKey)}</h3>

                {/* Desc */}
                <p className="text-sm text-gray-500 leading-relaxed">{t(s.descKey)}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Guarantees */}
        <div className="mt-20 bg-white border border-gray-100 rounded-3xl p-10 shadow-sm">
          <h3 className="text-center text-lg font-bold text-gray-900 mb-8">
            {t('howwework.guaranteesTitle')}
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {guarantees.map((g, i) => (
              <div key={i} className="flex items-start gap-3">
                <span className="text-2xl flex-shrink-0">{g.icon}</span>
                <p className="text-sm text-gray-600 leading-relaxed">{t(g.key)}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <a
            href="#get-started"
            className="inline-block bg-primary hover:bg-primary-dark text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-md"
          >
            {t('howwework.cta')}
          </a>
        </div>

      </div>
    </section>
  );
}